import { Banner } from '../banner/Banner';
import { CarRentalSaleSVG } from './CarRentalSaleSVG';

const CarRentalSaleContent = {
    tagline: 'Kampanje',
    header: 'Nå er det salg på leiebil',
    paragraph: 'Nå er det salg på leiebil på flere destinasjoner. Du finner gode tilbud på leiebil hos FINN reise.',
    callToAction: 'Sjekk utvalget!',
    path: '/reise/leiebil/?o=car_banner',
};

export const CarRentalSale = () => {
    const { tagline, header, paragraph, callToAction, path } = CarRentalSaleContent;

    return (
        <Banner
            tagline={tagline}
            header={header}
            text={paragraph}
            callToAction={callToAction}
            link={path}
            imgType="svg"
            svg={<CarRentalSaleSVG />}
            showShadow={false}
        />
    );
};
